import { supabase } from './supabase'

export interface ConsultingInquiry {
  id?: string
  name: string
  email: string
  business_name: string
  business_type: string
  message: string
  created_at?: string
}

const STORAGE_KEY = 'consulting_inquiries'

export const consultingService = {
  async submit(data: Omit<ConsultingInquiry, 'id' | 'created_at'>) {
    if (supabase) {
      try {
        const { data: result, error } = await supabase
          .from('consulting_inquiries')
          .insert([{
            name: data.name,
            email: data.email,
            business_name: data.business_name,
            business_type: data.business_type,
            message: data.message,
          }])
          .select()
          .single()

        if (error) {
          if (error.code === '23505') {
            return { success: false, duplicate: true }
          }
          throw error
        }
        return { success: true, data: result }
      } catch (error: any) {
        if (error?.code === '23505') {
          return { success: false, duplicate: true }
        }
        console.error('Supabase consulting inquiry error:', error)
        // Fall through to localStorage
      }
    }

    // localStorage fallback
    const inquiries: ConsultingInquiry[] = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || '[]'
    )

    const inquiry: ConsultingInquiry = {
      ...data,
      id: crypto.randomUUID(),
      created_at: new Date().toISOString(),
    }

    inquiries.push(inquiry)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(inquiries))
    return { success: true, data: inquiry }
  },
}
